<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            老人分类
        </div>
        <div style="padding: 20px;">

            <div>


                <el-row style="float: left;">
                    <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
                </el-row>

                <el-row style="float: right">
<!--                    <el-select v-model="status" placeholder="选择状态" @change="changeStatus" style="margin-right: 20px;width:120px;">-->
<!--                        <el-option-->
<!--                                v-for="item in options"-->
<!--                                :key="item.value"-->
<!--                                :label="item.label"-->
<!--                                :value="item.value">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
                    <!-- <el-button type="primary" @click.native="search">搜索</el-button> -->
                </el-row>


                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;">


                        <el-table-column prop="name" label="类型"  fixed></el-table-column>

                        <el-table-column prop="sort" label="排序" ></el-table-column>

                        <el-table-column prop="value" label="绑定值" ></el-table-column>

                        <el-table-column prop="addBalance" label="充值金额" ></el-table-column>

                        <el-table-column prop="governmentName" label="政府" ></el-table-column>

<!--                        <el-table-column prop="roleName" :formatter="roleNames" label="角色" ></el-table-column>-->

<!--                        <el-table-column prop="status" :formatter="statusTitle" label="状态" ></el-table-column>-->

<!--                        <el-table-column prop="governmentDTO" label="政府" >-->
<!--                            <template slot-scope="scope">-->
<!--                                <span v-if="scope.row.governmentDTO != null">{{scope.row.governmentDTO.name }}</span>-->
<!--                                <span v-if="scope.row.governmentDTO == null" style="color: red;">未设置</span>-->
<!--                            </template>-->
<!--                        </el-table-column>-->

<!--                        <el-table-column prop="createTime" label="注册日期">-->
<!--                            <template slot-scope="scope">-->
<!--                                <p>{{scope.row.createTime | timefilters }}</p>-->
<!--                            </template>-->
<!--                        </el-table-column>-->



                        <el-table-column fixed="right" label="操作" width="150">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.roleName != '超级管理员'" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            </template>
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>


        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import Add from "./Add";
    import Edit from "./Edit";

    // import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "../../common/times";
    import {hex_md5} from "../../common/Base64MD5";

    export default {
        name: "Page",

        //注册局部过滤器
        filters: {
            timefilters(val) {
                if (val == null || val == "") {
                    return "";
                } else {
                    let d = new Date(val);   //val 为表格内取到的后台时间
                    let month =
                        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
                    let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
                    let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
                    let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
                    let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
                    let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
                    return times;
                }
            }
        },

        data(){
            return{

                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,


                // options: [{
                //     value: -1,
                //     label: '全部状态'
                // }, {
                //     value: 0,
                //     label: '默认'
                // }, {
                //     value: 1,
                //     label: '已通过'
                // }, {
                //     value: 2,
                //     label: '被禁用'
                // }],
                status: -1,




                showModalAdd:false,
                showModalEdit:false,
                roleList:null,
                editStaff:null,

                th:0,

            }
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },
        components:{
            Add,Edit
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{

            toggleModalAdd:function(){
                this.$refs.myAdd.init();
                this.showModalAdd = !this.showModalAdd;
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },

            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            roleNames(){
                return '管理员'
            },
            search(){
                this.currentPage = 1;
                this.getList();
            },

            getList(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'ElderlyClass/Page',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        // staffCode: getStaffCode(),
                        // status:this.status,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            changeStatus:function(selVal){
                this.status = selVal;
            },


            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            handleDelete(index, row) {
                console.log(index, row);
            },


            statusTitle(row){
                if(row.status == 0){
                    return "默认";
                }
                if(row.status == 1){
                    return "已通过";
                }
                if(row.status == 2){
                    return "被禁用";
                }
                return "其它";
            },


        }
    }
</script>

<style scoped>

</style>
